// extracted by mini-css-extract-plugin
module.exports = {"title":"title-EJQ9e","close__text":"close__text-3JijS","header_wrapper":"header_wrapper-UCrSY","close__icon":"close__icon-35vNH"};